angular.module('gym.components').directive('signedWaiver', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      currency: '=',
      internal: '='
    },
    template: require('templates/components/waivers/signed_waiver.html.slim'),
    controller: ["$scope", "$rootScope", "$filter", function($scope, $rootScope, $filter) {
      var country, ref;
      $scope.walletDetails = $scope.waiver.signed_waiver_wallet_detail_attributes;
      $scope.contact = $scope.waiver.signed_waiver_contacts_attributes[0];
      country = ((ref = $rootScope.gym) != null ? ref.country : void 0) || window.DATA.gym_country;
      $scope.serviceAgreementUrl = (function() {
        switch (country) {
          case 'AU':
            return 'https://static.ezidebit.com.au/ServiceAgreement/AU/DDR_Service_Agreement.html';
          case 'NZ':
            return 'https://static.ezidebit.com.au/ServiceAgreement/NZ/DDR_Service_Agreement.html';
        }
      })();
      $scope.replaceMergeTags = function() {
        var contact, waiverDateValue, waiverForm;
        contact = $scope.waiver.signed_waiver_contacts_attributes[0];
        country = $scope.waiver.waiver_header_address_country;
        waiverDateValue = moment($scope.waiver.signed_at).format('MMMM Do YYYY');
        waiverForm = $scope.waiver.signed_waiver_form_attributes;
        waiverForm.gym_tacs_content = $filter('replaceWaiverMergeTags')(waiverForm.gym_tacs_content, contact, country);
        waiverForm.electronic_consent_content = $filter('replaceWaiverMergeTags')(waiverForm.electronic_consent_content, contact, country, waiverDateValue);
        return waiverForm.waiver_release_content = $filter('replaceWaiverMergeTags')(waiverForm.waiver_release_content, contact, country);
      };
      $scope.replaceMergeTags();
      $scope.membershipTerm = function(membership) {
        var number, unit;
        if (membership.term_number) {
          number = membership.term_number;
          unit = $filter('pluralize')(membership.term_unit, number);
          return `for ${number} ${unit}`;
        } else {
          return 'until further notice';
        }
      };
      $scope.displayMemberNumber = function(contact) {
        var signed_waiver;
        signed_waiver = $scope.waiver.signed_waiver_form_attributes;
        return signed_waiver.accept_member_number && contact.attending;
      };
      return $scope.firstContactMembershipDetailsPresent = function() {
        var ref1;
        return (((ref1 = $scope.waiver.signed_waiver_contacts_attributes[0]) != null ? ref1.membership_attributes : void 0) != null) && Object.keys($scope.waiver.signed_waiver_contacts_attributes[0].membership_attributes).length > 0;
      };
    }]
  };
});
